import React, { Component } from "react";
import {
  required,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Navbar,
  Modal,
  Pagination,
} from "../../components/CustomComponent.js";
import "../../components/global.js";

// แถวในตารางสิทธิ์ จัดกลุ่มตาม global.role_group
// เมนูที่ยังไม่ได้ระบุไว้ในกลุ่มไหน จะตกไปรวมท้ายกลุ่ม "อื่น ๆ" เพื่อไม่ให้เมนูใหม่หายจากตาราง
const buildRoleGroups = () => {
  const names = global.permission
    .filter((perm) => perm.includes("read"))
    .map((perm) => perm.split(".")[0]);
  const groups = (global.role_group || [])
    .map((group) => ({
      label: group.label,
      names: group.menus.filter((name) => names.includes(name)),
    }))
    .filter((group) => group.names.length);
  const used = new Set(groups.flatMap((group) => group.names));
  const rest = names.filter((name) => !used.has(name));
  if (rest.length) groups.push({ label: "อื่น ๆ", names: rest });
  return groups;
};

const ACTIONS = ["read", "create", "update", "delete"];

// ★ คีย์สิทธิ์ที่มีผลจริง = อยู่ใน global.permission เท่านั้น
//   บางเมนูไม่มีบาง action (เช่น ประวัติการขายอ่านอย่างเดียว) — ช่องนั้นเว้นว่าง ไม่มี checkbox
//   ปุ่ม "ทั้งหมด" ทุกแบบก็ติ๊ก/ล้างเฉพาะคีย์ชุดนี้ ไม่ประกอบ name.action เองจนได้คีย์ที่ไม่มีผล
const permissionExists = (key) => global.permission.includes(key);
const menuNames = () => [...new Set(global.permission.map((perm) => perm.split(".")[0]))];
const actionKeys = (action) => menuNames().map((name) => `${name}.${action}`).filter(permissionExists);
export default class Role extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      count: 0,

      id: "",
      uid: "",
      name: "",
      permission: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search } = this.state;
    loading(true);
    let body = {
      page: page,
      data_search: filter_search,
    };
    let result = await GET("api/admin/role/list", body);
    if (result?.status) {
      this.setState({ data: result.data, count: result.count, page: page || 1 });
    }
    loading(false);
  };
  GetByID = async (uid) => {
    loading(true);
    let body = { role_id: uid };
    let result = await GET("api/admin/role/list", body);
      this.setState({ ...result, modal_update: true });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, name, permission } = this.state;
    if (!name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาระบุชื่อบทบาท");
      return;
    }
    loading(true);
    let body = {
      name,
      permission,
    };
    let result = !uid
      ? await POST("api/admin/role/create", body)
      : await PUT("api/admin/role/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    }
    loading(false);
  };
  Delete = async (uid) => {
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการลบข้อมูลนี้หรือไม่?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("api/admin/role/delete/" + uid, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      data,
      count,
      name,
      permission,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="สิทธิ์ผู้ใช้งาน"
        />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">สิทธิ์ผู้ใช้งาน</h4>
          <div className="d-flex align-items-center flex-wrap">
            <input
              type="text"
              className="form-control wpx-250 me-2 mb-2"
              placeholder="ชื่อบทบาท..."
              onChange={(e) => {
                this.setState({ filter_search: e.target.value });
              }}
              value={filter_search}
            />
            <div className="d-flex">
              <button
                className="btn btn-success px-4 me-2 mb-2"
                onClick={() => {
                  this.Get(1);
                }}
              >
                ค้นหา
              </button>
              <button
                className="btn btn-outline-success px-4 me-2 mb-2"
                onClick={() => {
                  window.location.reload();
                }}
              >
                ล้างค่า
              </button>
            </div>
            <button
              className="btn btn-success px-4 ms-auto mb-2"
              onClick={async () => {
                this.setState({
                  modal_create: true,
                  id: "",
                  uid: "",
                  name: "",
                  permission: "",
                });
              }}
            >
              เพิ่มสิทธิ์ผู้ใช้งาน
            </button>
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="wpx-50 text-center">ลำดับ</th>
                    <th className="text-nowrap">ชื่อบทบาท</th>
                    <th className="text-center wpx-90">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td className="text-center">{((this.state.page || 1) - 1) * 10 + index + 1}</td>
                      <td className="text-nowrap">{item.name || ""}</td>
                      <td className="py-1">
                        <div className="d-flex justify-content-center">
                          {/* Update */}
                          <div
                            className="icon text-14 mx-1 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-warning-light text-orange"
                            onClick={async () => {
                              this.GetByID(item.uid);
                            }}
                          >
                            {"\uf044"}
                          </div>
                          {/* Delete */}
                          <div
                            className="icon text-14 mx-1 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-danger-light text-danger"
                            onClick={async () => {
                              this.Delete(item.role_id);
                            }}
                          >
                            {"\uf1f8"}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between p-3">
            <small>ทั้งหมด {count} รายการ</small>
            <Pagination
              count={Math.ceil(count / 10)}
              showFirstButton
              showLastButton
              onChange={(_, page) => {
                this.Get(page);
              }}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
          size="xl"
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create ? "สร้าง" : modal_update ? "แก้ไข" : ""}
              สิทธิ์ผู้ใช้งาน
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ชื่อสิทธิ์{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อสิทธิ์..."
                onChange={(e) => {
                  this.setState({ name: e.target.value });
                }}
                value={name}
              />
            </div>
            <div>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th className="bg-success">รายการ</th>
                    <th className="text-center bg-success">
                      <div>ทั้งหมด</div>
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const allPermissions = global.permission;

                          const updated = checked
                            ? [...new Set([...permission, ...allPermissions])]
                            : permission.filter(
                                (p) => !allPermissions.includes(p)
                              );
                          this.setState({ permission: updated });
                        }}
                        checked={global.permission.every((p) =>
                          permission.includes(p)
                        )}
                      />
                    </th>
                    {["read", "create", "update", "delete"].map((action) => (
                      <th className="text-center bg-success" key={action}>
                        <div>
                          {[
                            { en: "read", th: "ดู" },
                            { en: "create", th: "สร้าง" },
                            { en: "update", th: "แก้ไข" },
                            { en: "delete", th: "ลบ" },
                          ].find((e) => e.en === action)?.th || ""}
                        </div>
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const keys = actionKeys(action);

                            const updated = checked
                              ? [...new Set([...permission, ...keys])]
                              : permission.filter((p) => !keys.includes(p));

                            this.setState({ permission: updated });
                          }}
                          checked={actionKeys(action).every((key) =>
                            permission.includes(key)
                          )}
                        />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {buildRoleGroups().map((group) => (
                    <React.Fragment key={group.label}>
                      <tr>
                        <td colSpan={6} className="fw-bold bg-light">
                          {group.label}
                        </td>
                      </tr>
                      {group.names.map((name) => {
                      const actions = ACTIONS.filter((action) => permissionExists(`${name}.${action}`));

                      const renderCheckbox = (action) =>
                        !permissionExists(`${name}.${action}`) ? (
                          <td key={action} className="text-center text-secondary">-</td>
                        ) : (
                        <td key={action} className="text-center">
                          <input
                            type="checkbox"
                            checked={permission.includes(`${name}.${action}`)}
                            onChange={() => {
                              this.setState({
                                permission: permission.includes(
                                  `${name}.${action}`
                                )
                                  ? permission.filter(
                                      (p) => p !== `${name}.${action}`
                                    )
                                  : [...permission, `${name}.${action}`],
                              });
                            }}
                          />
                        </td>
                      );

                      return (
                        <tr key={name}>
                          <td>{global.role_name[name] || "-"}</td>
                          <td key={"all"} className="text-center">
                            <input
                              type="checkbox"
                              checked={actions.every((action) =>
                                permission.includes(`${name}.${action}`)
                              )}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                const updatedPermissions = checked
                                  ? [
                                      ...new Set([
                                        ...permission,
                                        ...actions.map(
                                          (action) => `${name}.${action}`
                                        ),
                                      ]),
                                    ]
                                  : permission.filter(
                                      (p) =>
                                        !actions.some(
                                          (action) => p === `${name}.${action}`
                                        )
                                    );

                                this.setState({
                                  permission: updatedPermissions,
                                });
                              }}
                            />
                          </td>
                          {ACTIONS.map(renderCheckbox)}
                        </tr>
                      );
                      })}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <button
              className="btn btn-success px-5 me-1"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              ยืนยัน
            </button>
            <button
              className="btn btn-outline-success px-5 ms-1"
              onClick={() => {
                this.setState({ modal_create: false, modal_update: false });
              }}
            >
              ยกเลิก
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
